import {
	ico_pop_blue,
	ico_pop_blue_smaller,
	ico_pop_green,
	ico_pop_green_smaller,
	ico_pop_grey,
	ico_pop_grey_smaller,
	ico_pop_naz,
	ico_pop_naz_smaller,
	ico_pop_orange,
	ico_pop_orange_smaller,
	ico_pop_yellow,
	ico_pop_yellow_smaller
} from "./map_configuration"

export const pageConfiguration = {
	open_stream_ab: {
		buttons: [],
		covered_ab: true,
		covered_cd: false,
		covered_agf: false,
		pops: false,
		acceptedTypes: ["CoveredAB"],
		saleableBuildings: [99, 102, 104, 105, 107, 109, 110, 114, 202],
		searchModes: [
			{ value: "address", viewValue: "SEARCH_METHOD.ADDRESS" },
			{ value: "id_building", viewValue: "SEARCH_METHOD.ID_BUILDING" }
		],
		icons: {
			pop_standard: ico_pop_naz,
			pop_smaller: ico_pop_naz_smaller,
			pcn_standard: ico_pop_naz,
			pcn_smaller: ico_pop_naz_smaller,
			pop_agf_standard: ico_pop_naz,
			pop_agf_smaller: ico_pop_naz_smaller
		}
	},
	open_stream_cd: {
		buttons: [],
		covered_ab: false,
		covered_cd: true,
		covered_agf: false,
		pops: false,
		acceptedTypes: ["CoveredCD", "CoveredFWA"],
		saleableBuildings: [99, 102, 104, 105, 107, 109, 110, 202, 205],
		searchModes: [
			{ value: "address", viewValue: "SEARCH_METHOD.ADDRESS" },
			{ value: "id_building", viewValue: "SEARCH_METHOD.ID_BUILDING" }
		],
		icons: {
			pop_standard: ico_pop_naz,
			pop_smaller: ico_pop_naz_smaller,
			pcn_standard: ico_pop_naz,
			pcn_smaller: ico_pop_naz_smaller,
			pop_agf_standard: ico_pop_naz,
			pop_agf_smaller: ico_pop_naz_smaller
		}
	},
	open_stream_agf: {
		buttons: [],
		covered_ab: false,
		covered_cd: false,
		covered_agf: true,
		pops: false,
		acceptedTypes: ["CoveredAGF"],
		saleableBuildings: [99, 102, 104, 105, 107, 109, 110, 202, 205],
		searchModes: [
			{ value: "address", viewValue: "SEARCH_METHOD.ADDRESS" },
			{ value: "id_building", viewValue: "SEARCH_METHOD.ID_BUILDING" }
		],
		icons: {
			pop_standard: ico_pop_naz,
			pop_smaller: ico_pop_naz_smaller,
			pcn_standard: ico_pop_naz,
			pcn_smaller: ico_pop_naz_smaller,
			pop_agf_standard: ico_pop_naz,
			pop_agf_smaller: ico_pop_naz_smaller
		}
	},
	open_internet_ab: {
		buttons: [],
		covered_ab: true,
		covered_cd: false,
		covered_agf: false,
		pops: false,
		acceptedTypes: ["CoveredAB"],
		saleableBuildings: [99, 102, 104, 105, 107, 109, 110, 114, 202],
		searchModes: [
			{ value: "address", viewValue: "SEARCH_METHOD.ADDRESS" },
			{ value: "id_building", viewValue: "SEARCH_METHOD.ID_BUILDING" }
		],
		icons: {
			pop_standard: ico_pop_naz,
			pop_smaller: ico_pop_naz_smaller,
			pcn_standard: ico_pop_naz,
			pcn_smaller: ico_pop_naz_smaller,
			pop_agf_standard: ico_pop_blue,
			pop_agf_smaller: ico_pop_blue_smaller
		}
	},
	open_internet_cd: {
		buttons: [],
		covered_ab: false,
		covered_cd: true,
		covered_agf: false,
		pops: false,
		acceptedTypes: ["CoveredCD"],
		saleableBuildings: [99, 102, 104, 105, 107, 109, 110],
		searchModes: [
			{ value: "address", viewValue: "SEARCH_METHOD.ADDRESS" },
			{ value: "id_building", viewValue: "SEARCH_METHOD.ID_BUILDING" }
		],
		icons: {
			pop_standard: ico_pop_naz,
			pop_smaller: ico_pop_naz_smaller,
			pcn_standard: ico_pop_naz,
			pcn_smaller: ico_pop_naz_smaller
		}
	},
	open_internet_agf: {
		buttons: [],
		covered_ab: false,
		covered_cd: false,
		covered_agf: true,
		pops: false,
		acceptedTypes: ["CoveredAGF"],
		saleableBuildings: [99, 102, 104, 105, 107, 109, 110],
		searchModes: [
			{ value: "address", viewValue: "SEARCH_METHOD.ADDRESS" },
			{ value: "id_building", viewValue: "SEARCH_METHOD.ID_BUILDING" }
		],
		icons: {
			pop_standard: ico_pop_naz,
			pop_smaller: ico_pop_naz_smaller,
			pcn_standard: ico_pop_naz,
			pcn_smaller: ico_pop_naz_smaller,
			pop_agf_standard: ico_pop_blue,
			pop_agf_smaller: ico_pop_blue_smaller
		}
	},
	pre_provisioning_kit: {
		buttons: ["pop", "pcn", "pop_agf", "pop_all"],
		covered_ab: true,
		covered_cd: true,
		covered_agf: true,
		pops: true,
		acceptedTypes: ["CoveredAGF"],
		saleableBuildings: [],
		searchModes: [
			{ value: "town", viewValue: "SEARCH_METHOD.TOWN" },
			{ value: "cluster", viewValue: "SEARCH_METHOD.CLUSTER" },
			{ value: "pop", viewValue: "SEARCH_METHOD.POP_PCN" }
		],
		icons: {
			pop_standard: ico_pop_naz,
			pop_smaller: ico_pop_naz_smaller,
			pcn_standard: ico_pop_orange,
			pcn_smaller: ico_pop_orange_smaller,
			pop_agf_standard: ico_pop_blue,
			pop_agf_smaller: ico_pop_blue_smaller
		}
	},
	pre_provisioning_svlan: {
		buttons: ["pop", "pcn", "pop_agf", "pop_all"],
		covered_ab: true,
		covered_cd: true,
		covered_agf: true,
		pops: true,
		acceptedTypes: ["CoveredAGF"],
		saleableBuildings: [],
		searchModes: [
			{ value: "town", viewValue: "SEARCH_METHOD.TOWN" },
			{ value: "cluster", viewValue: "SEARCH_METHOD.CLUSTER" },
			{ value: "pop", viewValue: "SEARCH_METHOD.POP_PCN" }
		],
		icons: {
			pop_standard: ico_pop_naz,
			pop_smaller: ico_pop_naz_smaller,
			pcn_standard: ico_pop_orange,
			pcn_smaller: ico_pop_orange_smaller,
			pop_agf_standard: ico_pop_blue,
			pop_agf_smaller: ico_pop_blue_smaller
		}
	},
	gpon_ab: {
		buttons: [],
		covered_ab: true,
		covered_cd: false,
		covered_agf: false,
		pops: false,
		acceptedTypes: ["CoveredAB"],
		saleableBuildings: [99, 102, 104, 105, 107, 109, 110, 114, 202],
		searchModes: [
			{ value: "address", viewValue: "SEARCH_METHOD.ADDRESS" },
			{ value: "id_building", viewValue: "SEARCH_METHOD.ID_BUILDING" }
		],
		icons: {
			pop_standard: ico_pop_naz,
			pop_smaller: ico_pop_naz_smaller,
			pcn_standard: ico_pop_naz,
			pcn_smaller: ico_pop_naz_smaller
		}
	},
	gpon_cd: {
		buttons: [],
		covered_ab: false,
		covered_cd: true,
		covered_agf: false,
		pops: false,
		acceptedTypes: ["CoveredCD"],
		saleableBuildings: [99, 102, 104, 105, 107, 109, 110],
		searchModes: [
			{ value: "address", viewValue: "SEARCH_METHOD.ADDRESS" },
			{ value: "id_building", viewValue: "SEARCH_METHOD.ID_BUILDING" }
		],
		icons: {
			pop_standard: ico_pop_naz,
			pop_smaller: ico_pop_naz_smaller,
			pcn_standard: ico_pop_naz,
			pcn_smaller: ico_pop_naz_smaller
		}
	},
	gpon_agf: {
		buttons: [],
		covered_ab: false,
		covered_cd: false,
		covered_agf: true,
		pops: false,
		acceptedTypes: ["CoveredAGF"],
		saleableBuildings: [99, 102, 104, 105, 107, 109, 110],
		searchModes: [
			{ value: "address", viewValue: "SEARCH_METHOD.ADDRESS" },
			{ value: "id_building", viewValue: "SEARCH_METHOD.ID_BUILDING" }
		],
		icons: {
			pop_standard: ico_pop_naz,
			pop_smaller: ico_pop_naz_smaller,
			pcn_standard: ico_pop_naz,
			pcn_smaller: ico_pop_naz_smaller,
			pop_agf_standard: ico_pop_blue,
			pop_agf_smaller: ico_pop_blue_smaller
		}
	}
}
